export default {
  toasts: {
    failed_to_delete_website: 'Échec de la suppression du site web',
    website_deleted: 'Site web supprimé',
  },
  delete_model: {
    title: 'Êtes-vous sûr de vouloir supprimer le site web ?',
    confirm: 'Supprimer',
    cancel: 'Annuler',
  },
  buttons: {
    open_editor: "Ouvrir l'éditeur",
    transfer_website: 'Transférer le site web',
    delete_site: 'Supprimer',
  },
};
